// ESLint Global var declaration

export default class FAQ {

  constructor() {

    this.currElem = {};
    this.currentlyOpenHeight = 0;

    const clickHandler = (e) => {
      const elem = $(e.currentTarget);
      const parentFAQ = elem.parent();
      let offsetHeight = 0;

      if (!parentFAQ.hasClass('is-open')) {
        let openIndex = -1;
        let openingIndex = -1;

        if (this.currElem.length > 0) {
          openIndex = $('.faq').index(this.currElem.parent());
          openingIndex = $('.faq').index(elem.parent());
        }

        if (openIndex >= 0 && openingIndex > openIndex) {
          offsetHeight = $(`.faq:eq(${openIndex})>.faq__content`).height() + 8;
        }

        // hide other open tabs
        if (parentFAQ.hasClass('faq--internal')) {
          $('.faq.faq--internal').removeClass('is-open');
          $('.faq.faq--internal>.faq__content').slideUp();
        } else {
          $('.faq').removeClass('is-open');
          $('.faq>.faq__content').slideUp();
        }

        $(e.currentTarget).parent().addClass('is-open');
        $(e.currentTarget).parent().find('>.faq__content').slideDown();

        this.currElem = elem;


        if ($(window).width() < 768) {
          const offset = $(e.currentTarget).parent().offset().top;
          const topOffset = 70;
          $('html,body').animate({ scrollTop: offset - offsetHeight - topOffset }, 350);
        }


      } else {
        // hide the currently opened faq
        $(e.currentTarget).parent().removeClass('is-open');
        $(e.currentTarget).parent().find('>.faq__content').slideUp();
      }

    };
    $('.faq>.expand').click(clickHandler);

    $('.faq>.expand[data-slug]').click((e) => {
      const slug = $(e.currentTarget).data('slug');
      history.replaceState(null, null, slug);
    });

    if ($('.should-open').length) {
      $('.faq.should-open').each((i, v) => {
        $(v).removeAttr('should-open');
        clickHandler({ currentTarget: $(v).find('>a')[0] });
      });
      const scroll = $('.faq.should-open').last().offset();
      $('html, body').stop().animate({ scrollTop: scroll.top - 100 }, 200);

      $('.faq.should-open').removeAttr('should-open');
    }
  }
}




// WEBPACK FOOTER //
// ./js/controllers/modules/FAQ.js